import type {
  AccountModel,
  PlanModel,
  StatusModel,
  UserStatus,
  VitallPatientModel,
} from 'generated/types';

export type AssignedCurator = {
  vitall_patient_id?: string;
  curator_user_id?: string | null;
  first_name?: string | null;
  last_name?: string | null;
};
export type AssignedPractitioner = {
  vitall_patient_id?: string;
  practitioner_user_id?: string | null;
  first_name?: string | null;
  last_name?: string | null;
};

export type AccountRelationship = 'primary' | 'child';

/**
 * Classify from account.parent_id, not parent_account.
 * parent_account only resolves when the parent is itself a root account
 * (parent_id is null), so it can be null for legitimate child accounts.
 */
export function getAccountRelationship(
  parent_id?: string | null
): AccountRelationship {
  return parent_id ? 'child' : 'primary';
}

export type Client = {
  vitall_id: string;
  user_id?: string;
  name: string;
  lastLogin?: string | null;
  newRecords?: number | null;
  publishedRecords?: number | null;
  draftRecords?: number | null;
  reviewRecords?: number | null;
  vitall_patient_id?: string | null;
  fhirID?: string | null;
  lastRecordUpdate?: string;
  userStatus: UserStatus;
  patient?:
    | (Pick<
        VitallPatientModel,
        'curator_user_id' | 'patient_id' | 'vitall_patient_id'
      > & {
        status?: Pick<
          StatusModel,
          | 'color'
          | 'internal'
          | 'private_name'
          | 'public_name'
          | 'sequence'
          | 'status_id'
        > | null;
      })
    | null;
  patientStatus?: string | null;
  curator?: AssignedCurator;
  practitioner?: AssignedPractitioner;
  parent_account?: Pick<AccountModel, 'account_id' | 'account_name'> | null;
  plan?: PlanModel | null;
  accountRelationship: AccountRelationship;
};
